import { render, staticRenderFns } from "./Academy_PRD.vue?vue&type=template&id=39e1c0f9"
import script from "./Academy_PRD.vue?vue&type=script&lang=js"
export * from "./Academy_PRD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports